export const MAIL_TEMPLATE = `{
  subject
  text
  id
  createdAt
  updatedAt
  standard
}`
